import moment from 'moment';
import _ from 'lodash';

function slideTitleFormatter(title) {
    let _title = title;

    if (!title || !title.length > 0) {
        _title = 'Ingen titel satt';
    }

    if (_.includes(title, '%vecka')) {
        _title = title.replace('%vecka', moment().week());
    }

    if (_.includes(title, '%månad')) {
        _title = title.replace('%månad', moment().format('MMMM'));
    }

    if (_.includes(title, '%kvartal')) {
        _title = title.replace('%kvartal', moment().format('Q'));
    }

    if (_.includes(title, '%år')) {
        _title = title.replace('%år', moment().format('YYYY'));
    }

    return _title;
}

function widgetTitleFormatter(widget) {
    let title = '';

    if (widget.dataType === 'closedSales' || widget.dataType === 'sales') {
        title += 'Försäljning';
    } else if (widget.dataType === 'bookedMeetings') {
        title += 'Bokade möten';
    } else if (widget.dataType === 'meetings') {
        title += 'Möten';
    } else if (widget.dataType === 'completedMeetings') {
        title += 'Genomförda möten';
    } else if (widget.dataType === 'planedMeetings') {
        title += 'Planerade möten';
    } else if (widget.dataType === 'opportunities') {
        title += 'Affärsmöjligheter';
    } else if (widget.dataType === 'createdOpportunities') {
        title += 'Skapade affärsmöjligheter';
    } else if (widget.dataType === 'activities' || widget.dataType === 'createdActivities') {
        title += 'Aktiviteter';
    } else if (widget.dataType === 'completedActivities') {
        title += 'Genomförda aktiviteter'
    } else if (widget.dataType === 'planedActivities') {
        title += 'Planerade aktiviteter'
    } else if (widget.dataType === 'saleCompetition') {
        title += 'Tävling'
    } else if (widget.dataType === 'saleCall') {
        title += 'Telefonsamtal'
    } else if (widget.dataType === 'forms') {
        title += 'Ifyllda formulär'
    } else if (_.includes(['totalVisits', 'topLeadSourceVisits', 'topViewsVisits'], widget.dataType)) {
        title += 'Webbsidebesök'
    } else if (widget.dataType === 'emailSent') {
        title += 'Skickade email'
    } else if (widget.dataType === 'open/clicked') {
        title += 'Öppnade/klickade email'
    }

    if (widget.dataConfig.period === 'currentYear') {
        title += ' innevarande år';
    } else if (widget.dataConfig.period === 'currentMonth') {
        title += ' innevarande månad';
    } else if (widget.dataConfig.period === 'currentQuarter') {
        title += ' innevarande kvartal';
    } else if (widget.dataConfig.period === 'currentWeek') {
        title += ' innevarande vecka';
    } else if (widget.dataConfig.period === 'nextWeek') {
        title += ' nästa vecka';
    } else if (widget.dataConfig.period === 'lastSevenDays') {
        title += ' senaste 7 dagarna';
    } else if (widget.dataConfig.period === 'lastThirtyDays') {
        title += ' senaste 30 dagarna';
    } else if (widget.dataConfig.period === 'lastNinetyDays') {
        title += ' senaste 90 dagarna';
    }

    // TODO: Set a custom title form the widget settings instead
    if (widget.dataType === 'customData') {
        title = 'Integrations';
    }

    return title;
}

export { slideTitleFormatter, widgetTitleFormatter };



/** WEBPACK FOOTER **
 ** ./client/lib/titleFormatter.js
 **/